<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="50"
      is-full-screen
    />
    <v-layout wrap justify-center fill-height>
      <v-flex xs12 sm12 md12 lg12>
        <v-img
          class="hidden-md-and-down"
          height="350px"
          :style="
            $vuetify.breakpoint.name == 'xs'
              ? 'height: 1500px'
              : $vuetify.breakpoint.name == 'sm'
              ? 'height: 700px'
              : $vuetify.breakpoint.name == 'md'
              ? 'height: 700px'
              : $vuetify.breakpoint.name == 'lg'
              ? 'height: 350px'
              : $vuetify.breakpoint.name == 'xl'
              ? 'height: 350px'
              : (style = 'height: 100%')
          "
          src="../../assets/images/Asset 1.png"
        >
          <v-layout justify-center wrap>
            <v-flex xs8 sm8 md8>
              <v-layout justify-center wrap pt-10 class="hidden-sm-and-down">
                <v-flex xs12 sm12 md12 lg12 pl-2 text-left>
                  <router-link
                    :to="'/SuperadminDashboard'"
                    style="text-decoration: none"
                  >
                    <span
                      style="
                        font-family: nunitosansextrabold;
                        color: white;
                        font-size: 22px;
                      "
                      >Dashboard</span
                    ><br />
                  </router-link>
                </v-flex>
              </v-layout>
              <v-layout justify-center wrap pt-12 class="hidden-md-and-up">
                <v-flex xs12 sm12 md12 lg12 text-left pt-10>
                  <router-link
                    :to="'/SuperadminDashboard'"
                    style="text-decoration: none"
                  >
                    <span
                      style="
                        font-family: nunitosansextrabold;
                        color: white;
                        font-size: 22px;
                      "
                      >Dashboard</span
                    ><br />
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout justify-center wrap py-2>
            <v-flex xs12 sm12 md9 lg9 xl9 pl-lg-12 px-lg-12 px-xl-12 pb-12>
              <v-layout justify-start wrap>
                <v-flex
                  xs3
                  sm3
                  md3
                  align-self-center
                  pa-5
                  v-for="(item, i) in card"
                  :key="i"
                >
                  <!-- <v-card> -->
                  <v-layout justify-center wrap>
                    <v-flex align-self-center px-xl-12 py-xl-4>
                      <!-- <v-overlay absolute dark color="transperent"> -->
                      <v-card
                        :to="item.to"
                        elevation="2"
                        color="white"
                        hover
                        :ripple="false"
                        max-height="200"
                        :max-width="
                          $vuetify.breakpoint.name == 'xl' ? '100%' : '100%'
                        "
                      >
                        <v-card-text
                          style="overflow-y: auto; height: 180px; width: 170px"
                        >
                          <v-img width="40px" :src="item.img"></v-img>
                          <v-flex xs12 pt-2>
                            <span class="title1">{{
                              item.title.slice(0, 50)
                            }}</span>
                          </v-flex>
                          <v-flex xs12 pt-5>
                            <span class="text1">{{ item.text }}</span>
                          </v-flex>
                        </v-card-text>
                      </v-card>
                      <!-- </v-overlay> -->
                    </v-flex>
                  </v-layout>
                  <!-- </v-card> -->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-img>
        <v-img
          class="hidden-lg-and-up"
          :style="
            $vuetify.breakpoint.name == 'xs'
              ? 'height: 1725px'
              : $vuetify.breakpoint.name == 'sm'
              ? 'height: 600px'
              : $vuetify.breakpoint.name == 'md'
              ? 'height: 510px'
              : $vuetify.breakpoint.name == 'lg'
              ? 'height: 820px'
              : (style = 'height: 100%')
          "
          src="../../assets/images/Asset 1.png"
        >
          <v-layout justify-center wrap>
            <v-flex xs8 sm8 md8>
              <v-layout justify-center wrap pt-1 class="hidden-sm-and-down">
                <v-flex xs12 sm12 md12 lg12 text-left>
                  <router-link
                    :to="'/SuperadminDashboard'"
                    style="text-decoration: none"
                  >
                    <span
                      style="
                        font-family: nunitosansextrabold;
                        color: white;
                        font-size: 22px;
                      "
                      >Dashboard</span
                    ><br />
                  </router-link>
                </v-flex>
              </v-layout>
              <v-layout
                justify-start
                wrap
                pt-12
                style="padding-top: 90px !important"
                class="hidden-md-and-up"
              >
                <v-flex xs12 sm12 md12 lg12 text-left>
                  <router-link
                    :to="'/SuperadminDashboard'"
                    style="text-decoration: none"
                  >
                    <span
                      style="
                        font-family: nunitosansextrabold;
                        color: white;
                        font-size: 22px;
                      "
                      >Dashboard</span
                    ><br />
                  </router-link>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout justify-center wrap>
            <v-flex xs12 sm12 md12 pb-12 pt-5>
              <v-layout justify-center wrap>
                <v-flex
                  align-self-center
                  px-5
                  pb-5
                  xs12
                  sm3
                  md3
                  v-for="(item, i) in card"
                  :key="i"
                >
                  <v-card
                    elevation="2"
                    color="white"
                    hover
                    :ripple="false"
                    max-height="200"
                    :max-width="
                      $vuetify.breakpoint.name == 'xs' ? '100%' : '350'
                    "
                    style="border: 9px solid red"
                  >
                    <v-card-text style="height: 180px; width: 170px">
                      <v-img width="40px" :src="item.img"></v-img>
                      <v-flex xs12 pt-2>
                        <span class="title1">{{ item.title }}</span>
                      </v-flex>
                      <v-flex xs12 pt-5>
                        <span class="text1">{{ item.text }}</span>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-img>
        <v-layout
          justify-center
          pa-5
          wrap
          pt-5
            v-if="
            $route.name != 'School Add' &&
            $route.name != 'Admin Add' &&
            $route.name != 'Admin List' &&
            $route.name != 'School List' &&
            $route.name != 'School View' 
          "
        >
          <v-flex xs12 sm8 md8>
            <School />
          </v-flex>
        </v-layout>
        <v-layout justify-center wrap pa-5 pt-8>
          <v-flex xs12 sm8 md10 lg8>
            <router-view> </router-view>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import School from "@/components/SuperAdmin/School/schoolList";
export default {
   components: {
    School,
  },
  data() {
    return {
      hover: false,
      appLoading: false,
      ServerError: false,
      attendence: [],
      notice: [],
      myText: "",
      card: [
        {
          img: require("../../assets/images/Group 282.png"),
          title: "Schools",
          text: "View/Add",
          to: "/schoolList",
        },
        {
          img: require("../../assets/images/Group 283.png"),
          title: "School Admins",
          text: "View/Add ",
          to: "/adminList",
        },
      ],
      searchKey: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    winStepperN(windowData) {
      if (windowData) {
        alert("mh");
        this.myText = windowData.myText.latestNoticeCount;
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/notice/getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.notice = response.data.latestNoticeCount;
          console.log(this.notice);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style>
.title1 {
  color: black;
  font-family: nunitosanssemibold;
  size: 10px;
}
.text1 {
  color: #606060;
  font-family: nunitosansregular;
}
</style>
